import { dateUtils } from 'utils/date-utils';

export const TransformDate = (value, original, ctx) => {
  if (ctx.isType(value)) return value;
  return dateUtils.format(original, dateUtils.DateIOFormats.keyboardDate);
};
